import { uniqueId } from "library/database/split-id.mjs"
import { PlanRoot } from "library/tree/constants.mjs"

const FOLDER_SCHEDULE_ANCHOR_TYPES = new Set(["schedule", "intro", "task"])

export function getFolderScopeNode(treeRoot, folderId) {
    if (!folderId) return null
    const folder = findTreeItemById(treeRoot, folderId)
    if (folder) return folder
    return { id: folderId, children: [] }
}

export function filterCommentsToFolderScope(comments, folder) {
    if (!shouldScopeToFolder(folder)) return comments ?? []
    const folderIds = getFolderIdentitySet(folder)
    if (!folderIds.size) return comments ?? []
    return (comments ?? []).filter((comment) => isCommentInFolderIdentitySet(comment, folderIds))
}

function shouldScopeToFolder(folder) {
    return !!folder && !folder[PlanRoot]
}

function isCommentInFolderIdentitySet(comment, folderIds) {
    if (!comment) return false
    // Comments only exist at schedule level or lower; keep those whose schedule lives within this
    // folder subtree. Accept both the raw shape (anchorType / selectionMetadata) and the normalized
    // client thread shape (anchor.type).
    const anchorType = comment.anchorType ?? comment.anchor?.type ?? getCommentAnchorType(comment.selectionMetadata)
    if (!FOLDER_SCHEDULE_ANCHOR_TYPES.has(anchorType)) return false
    return folderIds.has(getSchedulePathFolderIdentity(comment.schedulePath ?? comment.scheduleId))
}

function findTreeItemById(item, id) {
    if (!item || !id) return null
    if (`${item.id ?? item._id ?? ""}` === `${id}`) return item
    for (const child of item.children ?? []) {
        const found = findTreeItemById(child, id)
        if (found) return found
    }
    return null
}

function getFolderIdentitySet(folder, output = new Set()) {
    const id = getFolderIdentity(folder?.id ?? folder?._id)
    if (id) output.add(id)
    for (const child of folder?.children ?? []) {
        getFolderIdentitySet(child, output)
    }
    return output
}

function getSchedulePathFolderIdentity(schedulePath) {
    if (!schedulePath) return ""
    const text = `${schedulePath}`
    if (!text.includes("~")) return ""
    return getFolderIdentity(text.split("~")[0])
}

function getCommentAnchorType(selectionMetadata) {
    const root = selectionMetadata?.path?.[0]
    if (root === "sharelink") return "sharelink"
    if (root === "folder") return "folder"
    if (root === "intro") return "intro"
    if (root === "tasks") return "task"
    return "schedule"
}

function getFolderIdentity(value) {
    if (!value) return ""
    const text = `${value}`
    const bangParts = text.split("!")
    const local = bangParts[bangParts.length - 1]
    const routeParts = local.split("~")
    return uniqueId(routeParts[0] ?? local)
}
